module.exports = __webpack_public_path__ + "static/img/upright-base-weathering-steel.aeb0aa7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/general-frames/upright-base-weathering-steel.jpg
// module id = 721
// module chunks = 0